module.exports = __webpack_public_path__ + "static/23-6e9e6adcad653adca75053d6864571cc.jpg";